import { useMutation } from "urql";

import { CreateRestructureDetailDocument } from "../../../graphql/generated.ts";

export function useCreateRestructureDetail() {
  return useMutation(CreateRestructureDetailDocument);
}
